import { shallowEqual, useSelector } from 'react-redux';
import { getUserBalance } from '../selectors';

export const useUserBalance = () => ({
  coins: useSelector(getUserBalance, shallowEqual),
});
